import loader from "./index.vue";
export default loader;
